import { FunctionComponent } from "react";
import { Box, Center, Text, SimpleGrid, GridItem, Stack, HStack, Image} from "@chakra-ui/react"
import {SectionTitle} from "../../OikosDesignSystem/Typography";
import Section from "../../OikosDesignSystem/Sections/Section";

const TopicsSection: FunctionComponent = () => {

  const data = [
    "Interview Prep",
    "Cover Letter Review",
    "Application Review",
    "CV/Resume Review",
    "Non-Academic Career Help",
    "Personal Statement Review",
    "Writing Feedback",
    "Guided Reading",
    "Proposal Review",
    "Research/Thesis Help",
    "Subject/Industry Expertise",
    "Informational Interview",
  ]

  return (
    <>
      {/*<Section fontFamily={"lato"} color={"neutral-800"} bg={"neutral-300"}>*/}
      <Section bg={"neutral-300"} py={"10"}>
        <Stack spacing={18} px={{ base: '4', lg: '5' }}>
          <SectionTitle  textAlign={"center"} color={"primary-color-11"}>Office Hours</SectionTitle>
          <Center>
            <Text maxWidth={"525px"} fontSize={"4xl"} fontWeight={"bold"} textAlign={"center"}>
              Offering guidance on a variety of topics            </Text>
          </Center>

          <SimpleGrid p={[8, "60px"]} columns={[1, 2, 3]} spacingX={"40px"} spacingY={"20px"}>
            {
              data.map(
                (item) => {
                  return (
                    <HStack>
                      <Image src="../group.svg"/>
                      <Text fontSize={"xl"} fontWeight={"bold"} w={"350px"}>
                        {item}
                      </Text>
                    </HStack>
                  )
                }

              )
            }
          </SimpleGrid>
        </Stack>

      </Section>
    </>
  );
};

export default TopicsSection;
